import React, { useState } from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import GenerateConsolidateLayout from './components/generate_consolidate_layout';
import { useLocation } from 'react-router-dom';

const GenerateConsolidateInvoice = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [filter, setFilter] = useState({
        page : queryParams.get("page"),
        park_id : queryParams.get("park_id"),
        start_date : queryParams.get("start_date"),
        end_date : queryParams.get("end_date"),
    })

    return (
        <>
            <ContainerComponent top={20} span={16}>
                <GenerateConsolidateLayout default_filter={filter} />
            </ContainerComponent>
        </>
    );
}

export default GenerateConsolidateInvoice;